import { API_URL } from '../../../app-config/constants';
import { DateTimeSettingsDto } from '../../react/features/Admin/CompanySettings/types';
import { get, put } from '../request';

getDateTimeSettings.operation = 'READ';
export function getDateTimeSettings() {
    return get<DateTimeSettingsDto>(`${API_URL}/company-settings/date-time`);
}
setDateTimeSettings.operation = 'COMMAND';
export function setDateTimeSettings(dateTimeSettings: DateTimeSettingsDto) {
    return put(`${API_URL}/company-settings/date-time`, { postData: dateTimeSettings });
}
